import {
  jb_listing_grid_css_default
} from "./chunk.NRK4FFOY.js";
import {
  Spaceable,
  jbLinkClickedEventToJbTrackingEvent
} from "./chunk.LK5OUX7S.js";
import {
  Rt
} from "./chunk.LQ2ZH6PS.js";
import {
  customElement
} from "./chunk.QAGUCU4C.js";
import {
  ChangesBackgroundColor
} from "./chunk.6ORGI2J5.js";
import {
  D,
  ke,
  r
} from "./chunk.WKUNRGJV.js";
import {
  e,
  n
} from "./chunk.LWNTGWZJ.js";
import {
  __decorateClass
} from "./chunk.2QRLEY22.js";

// src/components/jb-listing-grid/jb-listing-grid.ts
var JbListingGrid = class extends ChangesBackgroundColor(Spaceable(r)) {
  firstUpdated() {
    this.style.setProperty(
      "--items-per-column",
      Math.ceil(this._grid.assignedElements().length / this.columns).toString()
    );
    this.style.setProperty("--column-count", this.columns.toString());
  }
  _getContentSpacingProperties() {
    const gridCols = this.variant === "wide" ? 12 : void 0;
    return {
      colsMdUp: gridCols,
      horizontal: this.variant ?? void 0,
      type: this.headline ? "list" : "list-without-heading"
    };
  }
  _tracking(e2) {
    const jbTrackingEvent = jbLinkClickedEventToJbTrackingEvent(e2, {
      component_name: "listing"
    });
    if (jbTrackingEvent) this.dispatchEvent(jbTrackingEvent);
  }
  render() {
    return ke`
      <div class=${Rt({ "listing-grid": true, [`cols${this.columns}`]: true, wide: this.variant === "wide" })}>
        ${this.headline ? ke`<h2 class="title">${this.headline}</h2>` : D}
        <div class="columns">
          <slot @jb-link:clicked=${this._tracking}></slot>
        </div>
      </div>
    `;
  }
};
JbListingGrid.styles = jb_listing_grid_css_default;
__decorateClass([
  n({ type: Number })
], JbListingGrid.prototype, "columns", 2);
__decorateClass([
  n()
], JbListingGrid.prototype, "headline", 2);
__decorateClass([
  n()
], JbListingGrid.prototype, "variant", 2);
__decorateClass([
  e("slot")
], JbListingGrid.prototype, "_grid", 2);
JbListingGrid = __decorateClass([
  customElement("jb-listing-grid")
], JbListingGrid);

export {
  JbListingGrid
};
